import {SEARCH_INVENTORY_ITEM, SET_LOGOUT_AUTH} from '../actions/Index';

const initState = {
  search: ''
};

export default function (state = initState, action: any): any {
  const {type, payload} = action;
  switch (type) {
    case SEARCH_INVENTORY_ITEM:
      return {
        search: payload
      };
    case SET_LOGOUT_AUTH:
      return {
        ...initState
      };
    default:
      return state;
  }
}
